<template>
</template>

<script>
    export default {
        name: 'Chat',
        beforeMount: function(){
            this.$router.push('/chat/list');    
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/List/Chat.vue